import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { configureApiClient } from './lib/api-client';
import { useAuthStore } from './stores/auth.store';

// Wire the api-client to the auth store. Doing this at startup avoids
// a circular import between api-client.ts and auth.store.ts.
configureApiClient({
  getTokens: () => {
    const s = useAuthStore.getState();
    return { accessToken: s.accessToken, refreshToken: s.refreshToken };
  },
  setTokens: (tokens) => useAuthStore.getState().setSession(tokens),
  onUnauthorized: () => useAuthStore.getState().clearSession(),
});

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
